<template>
    <v-dialog v-model="fullscreen" fullscreen>
        <div
            class="container"
            :style="`background-image: url(${backgroundImageUrl})`"
        >
            <div class="time-grid">
                <div
                    v-for="(digit, index) in timeDigits"
                    :key="index"
                    class="time-block"
                >
                    {{ digit }}
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import moment from 'moment-timezone';
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../../Layouts/GuestLayout.vue")
);

export default {
    layout: [GuestLayout],
    data() {
        return {
            location: "NY",
            timezone: "America/New_York",
            currentTime: moment("00:00", "HH:mm"),
            fullscreen: true,
        };
    },
    computed: {
        formattedTime() {
            return this.currentTime.format("HH:mm");
        },
        timeDigits() {
            return this.formattedTime.split("");
        },
        backgroundImageUrl() {
            return `/images/Clock/${this.location}.jpg`;
        },
    },
    mounted() {
        console.log(this.currentTime);
        // Get the 'location' parameter from the URL (e.g., ?location=NY)
        const urlParams = new URLSearchParams(window.location.search);
        this.location = urlParams.get("location") || "NY"; // Default fallback value if 'location' is not in the URL

        switch (this.location) {
            case "CN":
                this.timezone = "Asia/Shanghai";
                break;
            case "FR":
                this.timezone = "Europe/Paris";
                break;
            case "SF":
                this.timezone = "America/Los_Angeles";
                break;
            default:
                this.timezone = "America/New_York";
                break;
        }

        setInterval(() => {
            this.currentTime = moment().tz(this.timezone);
        }, 1000);
    },
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Take up the full height of the viewport */
    margin: 0;
    background-size: cover; /* Ensure the image covers the entire screen */
    /* background-position: center center;  */
    /* Center the image */
    background-attachment: fixed; /* Keep the background image fixed while scrolling */
}

/* Time grid layout */
.time-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 5 equal width columns */
    gap: 10px;
    justify-items: center;
    align-items: center;
    color: white;
    font-size: calc(30vw); /* Font size adjusts based on the viewport width */
    text-align: center;
    width: 90%; /* Clock grid takes up 90% of the screen width */
    max-width: 1200px; /* Max width to prevent it from getting too large on very wide screens */
}
@import url('https://fonts.googleapis.com/css2?family=Handjet:wght@100..900&display=swap');
.time-block {
    font-family: "Handjet", sans-serif;
    font-weight: 300;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    background-color: rgba(
        50,
        56,
        59,
        0.6
    ); /* Semi-transparent background for better visibility */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@media (max-width: 600px) {
    .time-grid {
        font-size: calc(12vw);
    }
}
</style>
